export const Provinces = {

    PROVINCE_1: {id: 1, text: 'Wien', value: 'province1'},
    PROVINCE_2: {id: 2, text: 'Niederösterreich', value: 'province2'},
    PROVINCE_3: {id: 3, text: 'Oberösterreich', value: 'province3'},
    PROVINCE_4: {id: 4, text: 'Salzburg', value: 'province4'},
    PROVINCE_5: {id: 5, text: 'Tirol', value: 'province5'},
    PROVINCE_6: {id: 6, text: 'Vorarlberg', value: 'province6'},
    PROVINCE_7: {id: 7, text: 'Burgenland', value: 'province7'},
    PROVINCE_8: {id: 8, text: 'Steiermark', value: 'province8'},
    PROVINCE_9: {id: 9, text: 'Kärnten', value: 'province9'},

    list() {
        return [
            this.PROVINCE_1,
            this.PROVINCE_2,
            this.PROVINCE_3,
            this.PROVINCE_4,
            this.PROVINCE_5,
            this.PROVINCE_6,
            this.PROVINCE_7,
            this.PROVINCE_8,
            this.PROVINCE_9
        ]
    },

    itemByValue(value) {
        return this.list().find(item => item.value === value)
    }

}
